import { objectToFrontEndFormat } from '@/services/ObjectFormatter'
import { addRUTHyphen } from '@/services/RUTFormatter'
import responseFormat from './json_formats/CustomerFormat'
import SlCustomerBranchOffice from '../../models/Sale/SlCustomerBranchOffice'
import CustomerModel from '../../models/Sale/SlCustomer'

const formatKeyObject = keyObj => {
    if (keyObj.field === 'rut') keyObj.value = addRUTHyphen(keyObj.value)
    return keyObj
}

const findByKey = async uniqueKey => {
    uniqueKey = formatKeyObject(uniqueKey)
    //Must use axios because we are using a custom endpoint for rut filtering
    let query = CustomerModel.where(uniqueKey.field, uniqueKey.value)
        .append('discount')
        .include(
            'sl_customer_presets_charge',
            'pch_payment_condition',
            'sl_ground_seller.hr_employee.g_user',
            'sl_customer_account',
            'main_core_business_sii'
        )
    if (uniqueKey.fetchMissingData)
        query = query.params({
            check_core_business: true,
        })
    let object = await query.first()
    let branchOfficesQuery = new SlCustomerBranchOffice()
        .where('sl_customer_id', object.id)
        .include(
            'g_commune',
            'sl_customer_ground_seller.sl_ground_seller.hr_employee.g_user'
        )
    /*
    if (uniqueKey.groundSellerId)
        branchOfficesQuery = branchOfficesQuery.where(
            'sl_ground_seller_id',
            uniqueKey.groundSellerId
        )
        */
    branchOfficesQuery = await branchOfficesQuery.get()
    object.branch_offices = branchOfficesQuery.data
    return objectToFrontEndFormat(object, responseFormat)
}

const find = async (id, fetchMissingData = null, groundSellerId = null) => {
    let query = CustomerModel.append('discount').include(
        'sl_customer_presets_charge',
        'pch_payment_condition',
        'sl_ground_seller.hr_employee.g_user',
        'sl_customer_account',
        'g_core_business_sii',
        'main_core_business_sii'
    )
    if (fetchMissingData)
        query = query.params({
            check_core_business: true,
        })
    let obj = await query.find(id)
    let branchOfficesQuery = new SlCustomerBranchOffice()
        .where('sl_customer_id', obj.id)
        .include(
            'g_commune',
            'sl_customer_ground_seller.sl_ground_seller.hr_employee.g_user'
        )
    /*
    if (groundSellerId)
        branchOfficesQuery = branchOfficesQuery.where(
            'sl_ground_seller_id',
            groundSellerId
        )
        */
    branchOfficesQuery = await branchOfficesQuery.get()
    obj.branch_offices = branchOfficesQuery.data
    return objectToFrontEndFormat(obj, responseFormat)
}

export default {
    // get,
    findByKey,
    find,
}
